import { render, staticRenderFns } from "./applyTableDetail.vue?vue&type=template&id=bf6b1d4e"
import script from "./applyTableDetail.vue?vue&type=script&lang=js"
export * from "./applyTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports